export default __webpack_public_path__ + "static/media/procesing.c80d980a.png";